export function convertToNumber(value: string): string {
    const matchResult = /,[0-9]+$/.exec(value);

    if (matchResult && matchResult.index) {
        const beforeFraction = value.slice(0, Math.max(0, matchResult.index)).replace(/[,.]/, '');
        const afterFraction = value.slice(Math.max(0, matchResult.index + 1)).replace(/[,.]/, '');

        return afterFraction.length > 0 ? Number(`${beforeFraction}.${afterFraction}`).toFixed(afterFraction.length) : beforeFraction;
    }

    return value;
}
